import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  remainder: {
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
  transfer: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  type: {
    textTransform: "capitalize",
  },
}));

export default useStyles;
